module.exports = __webpack_public_path__ + "static/list_with_meeting_attendees-6d00862f6a2d5ace3234807706932017.png";